var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitingCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36525 9.53747L16.8559 9.53747M16.8559 5.35292L14.2419 5.35292L8.36524 5.35292M16.8559 13.3113L5.16749 13.3113M18.0991 0.526925L6.50136 0.526926C6.07395 0.526926 5.66451 0.698912 5.36525 1.00414L1.10186 5.35292C0.810293 5.65027 0.646972 6.05016 0.646972 6.46668L0.646972 13.3113L0.646973 16.3621C0.646973 17.2408 1.35928 17.9531 2.23795 17.9531L20.606 17.9531C21.4846 17.9531 22.197 17.2408 22.197 16.3621L22.197 2.1179C22.197 1.23929 21.4846 0.526925 20.606 0.526925L18.0991 0.526925Z",
    stroke: "current",
    strokeWidth: 0.985714,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitingCard);
export default __webpack_public_path__ + "static/media/visitingCard.e1510162d6376ec71f2664a4b9ac607c.svg";
export { ForwardRef as ReactComponent };